/*
 * @Descripttion: types
 * @Author: juanjuanhui
 * @Date: 2022-02-21 09:03:54
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-07 14:28:12
 */
export const GET_ACCESS_TOKEN = "GET_ACCESS_TOKEN";
export const SAVE_HEAD_MENU_PATH = "SAVE_HEAD_MENU_PATH";
export const CHANGE_SEARCH_NAME = "CHANGE_SEARCH_NAME";
